import { render, staticRenderFns } from "./Rolelist.vue?vue&type=template&id=8f8fd380&scoped=true"
import script from "./Rolelist.vue?vue&type=script&lang=js"
export * from "./Rolelist.vue?vue&type=script&lang=js"
import style0 from "./Rolelist.vue?vue&type=style&index=0&id=8f8fd380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8fd380",
  null
  
)

export default component.exports